var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "py-4"
  }, [_c('div', {
    staticStyle: {
      "position": "relative",
      "overflow": "auto"
    }
  }, [!_vm.loading ? _c('table', {
    staticClass: "w-100 border",
    staticStyle: {
      "position": "relative"
    }
  }, [_vm._m(0), _c('tbody', [_vm.dataReport.length ? _vm._l(_vm.dataReport, function (item, index) {
    var _item$form, _item$form$vehicle, _item$form$vehicle$ve, _item$form2, _item$form2$user_pic;
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "col-1 bg-white sticky"
    }, [_vm._v(_vm._s(_vm.getRowNumber(index)))]), _c('td', {
      staticClass: "col-2 bg-white sticky"
    }, [_c('b-badge', {
      attrs: {
        "variant": "success"
      }
    }, [_vm._v(_vm._s(item.form.vehicle.name))])], 1), _c('td', {
      staticClass: "col-3 sticky bg-white text-truncate"
    }, [_vm._v(" " + _vm._s((_item$form = item.form) === null || _item$form === void 0 ? void 0 : (_item$form$vehicle = _item$form.vehicle) === null || _item$form$vehicle === void 0 ? void 0 : (_item$form$vehicle$ve = _item$form$vehicle.vehicle_type) === null || _item$form$vehicle$ve === void 0 ? void 0 : _item$form$vehicle$ve.name) + " ")]), _c('td', {
      staticClass: "text-truncate"
    }, [_c('div', {
      staticClass: "px-2 bg-danger",
      staticStyle: {
        "border-radius": "4px"
      }
    }, [_vm._v(_vm._s(item.task_type.name))])]), _c('td', {
      staticClass: "text-truncate"
    }, [_vm._v(_vm._s(_vm.formatDateTime(item === null || item === void 0 ? void 0 : item.start_at)) + " ")]), _c('td', {
      staticClass: "text-truncate"
    }, [_vm._v(_vm._s(_vm.formatDateTime(item === null || item === void 0 ? void 0 : item.estimated_finished_at)) + " ")]), _c('td', {
      staticClass: "text-truncate text-center"
    }, [_vm._v(_vm._s(_vm.totalDays(item === null || item === void 0 ? void 0 : item.start_at, item === null || item === void 0 ? void 0 : item.estimated_finished_at)) + " days")]), _c('td', {
      staticClass: "text-truncate"
    }, [_vm._v(_vm._s(_vm.formatDateTime(item.actual_started_at)) + " ")]), _c('td', {
      staticClass: "text-truncate"
    }, [_vm._v(_vm._s(_vm.formatDateTime(item.actual_finished_at)) + " ")]), _c('td', {
      staticClass: "text-truncate text-center"
    }, [_vm._v(_vm._s(_vm.totalDays(item === null || item === void 0 ? void 0 : item.actual_started_at, item === null || item === void 0 ? void 0 : item.actual_finished_at)) + " days")]), _c('td', {
      staticClass: "text-truncate"
    }, [_vm._v(_vm._s(_vm.formatCurrency(item.cost_estimate)))]), _c('td', {
      staticClass: "text-truncate"
    }, [_vm._v(_vm._s(_vm.formatCurrency(item.cost_real)))]), _c('td', {
      staticClass: "text-truncate"
    }, [_vm._v(_vm._s(item.name == 'Others' ? item.other_name : item.name))]), _c('td', {
      staticClass: "text-truncate"
    }, [_vm._v(_vm._s(item.title))]), _c('td', {
      staticClass: "text-truncate"
    }, [_vm._v(_vm._s(_vm.findTextDoneBy(item.done_by) || '-'))]), _c('td', {
      staticClass: "text-truncate"
    }, [_vm._v(_vm._s(((_item$form2 = item.form) === null || _item$form2 === void 0 ? void 0 : (_item$form2$user_pic = _item$form2.user_pic) === null || _item$form2$user_pic === void 0 ? void 0 : _item$form2$user_pic.username) || '-'))])]);
  }) : [_vm._m(1)]], 2)]) : [_c('div', {
    staticClass: "w-100 d-flex justify-content-center my-5"
  }, [_c('b-spinner', {
    staticStyle: {
      "width": "64px",
      "height": "64px"
    }
  })], 1)]], 2), _vm.dataReport.length ? _c('div', {
    staticClass: "mt-4 d-flex align-items-center w-100 justify-content-end"
  }, [_c('b-form-select', {
    staticStyle: {
      "width": "140px"
    },
    attrs: {
      "plain": "",
      "options": _vm.limitOptions
    },
    on: {
      "input": _vm.fetchData
    },
    model: {
      value: _vm.meta.perPage,
      callback: function callback($$v) {
        _vm.$set(_vm.meta, "perPage", $$v);
      },
      expression: "meta.perPage"
    }
  }), _c('b-pagination', {
    staticClass: "mb-0 ml-3",
    attrs: {
      "total-rows": _vm.meta.totalItems,
      "per-page": _vm.meta.perPage,
      "first-number": "",
      "align": "center"
    },
    on: {
      "change": function change(page) {
        _vm.meta.page = page;
        _vm.fetchData();
      }
    },
    model: {
      value: _vm.meta.page,
      callback: function callback($$v) {
        _vm.$set(_vm.meta, "page", $$v);
      },
      expression: "meta.page"
    }
  })], 1) : _vm._e()]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('thead', [_c('th', {
    staticClass: "col-1 sticky"
  }, [_vm._v("No.")]), _c('th', {
    staticClass: "col-2 sticky"
  }, [_vm._v("Vessel Name")]), _c('th', {
    staticClass: "col-3 sticky"
  }, [_vm._v("Vessel Type")]), _c('th', {
    staticClass: "text-truncate"
  }, [_vm._v("Type R & M")]), _c('th', {
    staticClass: "text-truncate"
  }, [_vm._v("Est Start Date")]), _c('th', {
    staticClass: "text-truncate"
  }, [_vm._v("Est End Date")]), _c('th', {
    staticClass: "text-truncate"
  }, [_vm._v("Est Total Days")]), _c('th', {
    staticClass: "text-truncate"
  }, [_vm._v("Actual Start Date")]), _c('th', {
    staticClass: "text-truncate"
  }, [_vm._v("Actual End Date")]), _c('th', {
    staticClass: "text-truncate"
  }, [_vm._v("Actual Total Days")]), _c('th', {
    staticClass: "text-truncate"
  }, [_vm._v("Est Cost Item")]), _c('th', {
    staticClass: "text-truncate"
  }, [_vm._v("Real Cost Item")]), _c('th', {
    staticClass: "text-truncate"
  }, [_vm._v("Equipment")]), _c('th', {
    staticClass: "text-truncate"
  }, [_vm._v("Work Item")]), _c('th', {
    staticClass: "text-truncate"
  }, [_vm._v("Done By")]), _c('th', {
    staticClass: "text-truncate"
  }, [_vm._v("PIC")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('tr', [_c('td', {
    attrs: {
      "colspan": "11"
    }
  }, [_vm._v(" No Data Here ")])]);

}]

export { render, staticRenderFns }